<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    width="30%"
    :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px" class="biz-dialog-form">
      <el-form-item label="业务名称" prop="roleName">
        <el-input v-model="dataForm.roleName" placeholder="业务名称"></el-input>
      </el-form-item>
      <el-form-item label="租户" prop="tenant">
        <el-input
        v-model="dataForm.tenant" 
        clearable 
        @change="changeTenantCallback"
        placeholder="请选择" 
        style="width: 100%">
        </el-input>
      </el-form-item>       
      <el-form-item label="实体表名" prop="mtp">
        <el-input 
        v-model="dataForm.mtpName" 
        ref="usertype_input" 
        :readonly="true"
        placeholder="点击选择类型"
        class="menu-list__input">
        </el-input>
      </el-form-item>              
      <el-form-item label="备注" prop="remark">
        <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col style="text-align: right;">
        <el-button size="small" @click="view.visible = false">取消
        </el-button>
        <el-button size="small" type="primary" @click="dataFormSubmit()">确定
        </el-button>       
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        view: {
          visible: false,
          conheight: {
            height: this.$store.state.common.documentClientDefaultHeight * 0.9 - 410 + 'px',
            'overflow-y': 'auto'
          }
        },
        viewData: {
        },
        dataForm: {
          id: 0,
          roleName: '',
          mtp: '',
          remark: '',
          tenant: '',
          mtpName: ''
        },
        dataRule: {
          roleName: [
            { required: true, message: '角色名称不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.view.visible = true
        // TODO
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            //TODO
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .el-dialog__body{
    .biz-dialog-form{
      width: 95%;
      .el-select{
        width: 222px;
      }
    }
  }
</style>